module.exports = __webpack_public_path__ + "r-v3/img/menu_attendance_white.572e422d.svg";